import { HealthcareDashboard } from "@/components/HealthcareDashboard";

const Dashboard = () => {
  return (
    <div className="h-full min-h-0">
      <HealthcareDashboard />
    </div>
  );
};

export default Dashboard;
